import { piTotalMinor, totalMinor } from "@hisense/shared";

/**
 * Khối tổng của MỘT chứng từ thương mại — dòng, phụ phí, chiết khấu, tổng cuối.
 *
 * Đây là chỗ DUY NHẤT làm phép này. Trước 15/09/2026 nó nằm ở ba nơi:
 * `piDocumentFacts`, `printInvoice` và khối tổng của CSV — và nơi thứ ba làm
 * tròn HAI LẦN (`totalMinor(totalMinor(dòng) + phụ phí)`) trong khi hai nơi kia
 * làm tròn một lần sau khi cộng. Hai công thức lệch nhau một xu ở đúng những số
 * nằm giữa, nên cùng một hoá đơn xuất ra hai tệp ghi hai con số khác nhau.
 *
 * Tệ hơn: dòng TỔNG CUỐI của CSV lại lấy thẳng `piTotalMinor`, nên tệp đó tự
 * mâu thuẫn — cộng cột không ra chính dòng tổng cuối của nó. Khối tổng được
 * thêm vào CSV chính là để kế toán khỏi cộng ra một số khác số trên chứng từ;
 * làm tròn lệch đã phá đúng điều đó.
 *
 * `piTotalMinor` là trọng tài: nó là hàm đã tính ra con số lưu trong CSDL.
 */
export interface DocumentTotalsInput {
  items: readonly { amount: number }[];
  upcharge?: number | null;
  discount?: number | null;
}

export function documentTotals(doc: DocumentTotalsInput) {
  const lineSubtotal = doc.items.reduce((n, it) => n + it.amount, 0);
  const upcharge = doc.upcharge ?? 0;
  const discount = doc.discount ?? 0;
  // Làm tròn MỘT LẦN, sau khi cộng phụ phí — giống hệt `piTotalMinor`.
  const base = totalMinor(lineSubtotal + upcharge);
  const less = discount ? totalMinor((base * discount) / 10_000) : 0;
  return {
    lineSubtotal,
    upcharge,
    base,
    discountPct: discount / 100,
    less,
    /** Tổng cuối theo công thức. Chứng từ đã lưu có thể lệch — xem nơi gọi. */
    grand: piTotalMinor(lineSubtotal, upcharge, discount),
  };
}
